export default __webpack_public_path__ + "static/media/instruction5.c872ceea.png";